import * as Highcharts from 'highcharts/highstock';
import { measurement } from '@lib/measurement';
import { parsePsdControlLines } from '../../../../../shared-utils/psd-control-lines';

function isPsdSummaryLine(series: Highcharts.SeriesOptionsType): boolean {
    const line = series as Highcharts.SeriesLineOptions;
    return line.type === 'line' && line.name == null && line.dashStyle === 'ShortDash' && line.enableMouseTracking === false;
}

/** Add configured Analytics controls and replace the generated summary references while controls are visible. */
export function addPsdControlLines(options: Highcharts.Options, serialized: string, percents: Map<number, string>, abbreviation: string): Highcharts.Options {
    if (!options) return options;

    const units: Record<string, measurement.Unit> = {
        mm: 'millimeter',
        cm: 'centimeter',
        m: 'meter',
        in: 'inch'
    };
    const unit = units[abbreviation];
    if (!unit) return options;

    let controls;
    try {
        controls = parsePsdControlLines(serialized);
    }
    catch {
        return options;
    }

    const lines: Highcharts.YAxisPlotLinesOptions[] = controls.filter(control => percents.has(control.percent)).map(control => {
        const value = measurement.convertFromBaseUnits(control.value, unit);
        return {
            id: `psd-control-${control.percent}`, value,
            color: percents.get(control.percent), width: 2, dashStyle: 'Dot', zIndex: 5,
        };
    });

    if (!lines.length)
        return options;
    
    const original = (Array.isArray(options.yAxis) ? options.yAxis[0] : options.yAxis) || {};
    const axis: Highcharts.YAxisOptions = {
        ...original,
        plotLines: [...(original.plotLines || []), ...lines],
        softMin: Math.min(original.softMin ?? Infinity, ...lines.map(line => line.value)),
        softMax: Math.max(original.softMax || 0, ...lines.map(line => line.value))
    };

    return {
        ...options,
        series: options.series?.filter(series => !isPsdSummaryLine(series)),
        yAxis: Array.isArray(options.yAxis) ? [axis, ...options.yAxis.slice(1)] : axis,
    };
}
